import { motion } from "framer-motion";

// Running-track lanes drawn in on load; purely decorative.
export const TrackLines = ({ className = "", color = "#0E0E10" }) => (
  <svg viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice" className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} aria-hidden="true">
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <motion.ellipse key={i} cx="1020" cy="760" rx={300 + i * 95} ry={220 + i * 80} fill="none" stroke={color}
        strokeWidth={i === 2 ? 1.6 : 0.8} strokeDasharray={i === 2 ? "0" : "4 10"} opacity={i === 2 ? 0.35 : 0.22}
        initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 2.6, delay: 0.2 + i * 0.12, ease: [0.22, 1, 0.36, 1] }} />
    ))}
  </svg>
);
